// polyfills
import 'core-js/fn/array/from';
import './modules/polyfills';

// detect mobile devices
import './modules/mobileDetect';

// external svg support for old browsers
import 'svgxuse';

// jQuery
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

// form validation
import 'parsleyjs';

// modules
import { overlay } from './modules/overlay';
import { placeholder } from './modules/placeholder';
import { dpLogo } from './modules/dpLogo';
import { intro } from './modules/intro';
import { nav } from './modules/nav';
import { advantages } from './modules/advantages';
import { smartphone } from './modules/smartphone';
import { calculation } from './modules/calculation';
import { customSelect } from './modules/customSelect';
import { scrollTo } from './modules/scrollTo';
import { pagePreload } from './modules/pagePreload';
import { animate } from './modules/animate';
import { parallax } from './modules/parallax';
import { faq } from './modules/faq';
import { popup } from './modules/popup';
import { ytVideo } from './modules/ytVideo';
import { googleMaps } from './modules/googleMaps';
import { countdown } from './modules/countdown';
import { reviews } from './modules/reviews';
import { partners } from './modules/partners';
import { benefits } from './modules/benefits';
import { related } from './modules/related';
import { addToRequest } from './modules/addToRequest';
import { Auth } from './modules/auth';
import { special } from './modules/special';
import { tooltip } from './modules/tooltip';
import { fbShare } from './modules/fbShare';
import { datepicker } from './modules/datepicker';
import { recharge } from './modules/recharge';
import { form } from './modules/form';
import { telMask } from './modules/telMask';
import { optional } from './modules/optional';
import { headHint } from './modules/headHint';
import { langDropdown } from './modules/langDropdown';

window.overlay = overlay;
window.popup = popup;
window.authorization = new Auth();
window.initModules = () => {
    placeholder();
    dpLogo();
    intro();
    nav();
    advantages();
    smartphone();
    calculation();
    customSelect();
    scrollTo();
    animate();
    parallax();
    faq();
    popup();
    ytVideo();
    googleMaps();
    countdown();
    reviews();
    partners();
    benefits();
    related();
    addToRequest();
    telMask();
    special();
    tooltip();
    fbShare();
    datepicker();
    recharge();
    form();
    optional();
    headHint();
    langDropdown();
};

if (document.readyState === 'complete') {
    if (!document.body.classList.contains('preload')) {
        initModules();
    } else {
        pagePreload(initModules);
    }
} else if (document.readyState === 'interactive' && !document.body.classList.contains('preload')) {
    initModules();
} else {
    document.addEventListener('DOMContentLoaded', () => {
        if (!document.body.classList.contains('preload')) {
            initModules();
        }
    });

    window.addEventListener('load', () => {
        if (document.body.classList.contains('preload')) {
            pagePreload(initModules);
        }
    });
}